# This gets automatically populated bij gulp

exports.date = 1456230683
exports.branch = "master"
exports.hash = "4f9f713"
exports.build = 1587
exports.version = "#{exports.branch}/#{exports.hash}"



/** WEBPACK FOOTER **
 ** ./build/Version.coffee
 **/